import * as TypeGraphQL from "type-graphql";
export var OpenaiModel;
(function (OpenaiModel) {
    OpenaiModel["GPT_5"] = "GPT_5";
    OpenaiModel["GPT_5_MINI"] = "GPT_5_MINI";
    OpenaiModel["GPT_5_NANO"] = "GPT_5_NANO";
    OpenaiModel["GPT_4_1"] = "GPT_4_1";
    OpenaiModel["GPT_4_1_MINI"] = "GPT_4_1_MINI";
    OpenaiModel["GPT_4_1_NANO"] = "GPT_4_1_NANO";
})(OpenaiModel || (OpenaiModel = {}));
TypeGraphQL.registerEnumType(OpenaiModel, {
    name: "OpenaiModel",
    description: undefined,
});
//# sourceMappingURL=OpenaiModel.js.map